import { Component, ChangeDetectionStrategy } from '@angular/core'
import { credits, currentYear } from '@common/constants'

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class FooterComponent {
  year = currentYear;
  platformName = credits.platformName;
  name = credits.name;
}
